// src/base62.ts
import baseX from "base-x";
var internal = baseX("0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ");
var base62 = {
  encode: (input) => internal.encode(typeof input == "string" ? new TextEncoder().encode(input) : input),
  decode: (input) => new TextDecoder().decode(internal.decode(input)),
  decodeRaw: (input) => internal.decode(input)
};
export {
  base62
};
//# sourceMappingURL=index.mjs.map